module.exports = __webpack_public_path__ + "static/media/hue1.b8b2abae.png";